import React, { useLayoutEffect, useRef, useState } from 'react';

/** 원본보다 확대하지 않고 가로·세로 모두 칸 안에 맞춘다. bbox도 실제 이미지 크기를 따른다. */
export default function OcrSourcePreview({ src, alt, onError, children }) {
  const frameRef = useRef(null);
  const [frame, setFrame] = useState({ width: 0, height: 0 });
  const [natural, setNatural] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const element = frameRef.current;
    const measure = () => {
      const { clientWidth: width, clientHeight: height } = element;
      setFrame((previous) => previous.width === width && previous.height === height ? previous : { width, height });
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  const scale = natural.width && natural.height
    ? Math.min(1, frame.width / natural.width, frame.height / natural.height) : 0;
  return (
    <div ref={frameRef} className="relative flex min-h-0 flex-1 items-center justify-center">
      <div className="relative shrink-0" style={{ width: natural.width * scale, height: natural.height * scale }}>
        <img
          src={src}
          alt={alt}
          className="block size-full max-w-none rounded-lg shadow"
          onLoad={(event) => setNatural({ width: event.currentTarget.naturalWidth, height: event.currentTarget.naturalHeight })}
          onError={onError}
        />
        {scale > 0 && children}
      </div>
    </div>
  );
}
